// removed by extract-text-webpack-plugin
module.exports = {"button":"src-components-IndexLinkButton----index-module---button---28sDl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IndexLinkButton/index.module.css
// module id = 427
// module chunks = 168707334958949